import React from "react";
import ProductSection from "../PageSections/ProductsSection";
import ProductSection1 from "../PageSections/ProductsSection1";
import VetlinesSection from "../PageSections/VetlinesSection";
import VetlinesProducts from "../PageSections/VetlinesProducts";
import VetlinesRepresentative from "../PageSections/VetlinesRep";

export default function ProductsPage () {
    return (
        <>
            <div className="sm:px-16 px-6 flex justify-center items-start pt-16 md:mt-[20px] mt-[35px]">
                <ProductSection />
            </div>

            <VetlinesSection />
            <VetlinesProducts />
            <VetlinesRepresentative />

            <div className="sm:px-16 px-6 flex justify-center items-start">
                <ProductSection1 />
            </div>
        </>
    )
}